import React from "react";
import { Modal, Box, Button, Typography } from "@mui/material";
import "./FlexibleModal.css";
import { SelectInput } from "../../components/inputs/SelectInput/SelectInput";
import { MultiSelectInput } from "../../components/inputs/MultiSelectInput/MultiSelectInput";
import { TextInput } from "../../components/inputs/TextInput/TextInput";
import { TextArea } from "../../components/inputs/TextArea/TextArea";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#F7F7F7",
  border: "1px solid #ABABAB",
  borderRadius: "10px",
  p: '20px',
  minWidth: 320
};

export const FlexibleModal = ({
  open,
  onClose,
  fieldKey,
  fieldValue,
  setFieldValue,
  onSave,
  placeholder,
}) => {
  const [errors, setErrors] = React.useState({});

  const handleChange = (e) => {
    let value = e.target.value;
    if (fieldKey === "salary") {
      const raw = value.replace(/\D/g, "");
      const numberValue = Number(raw) / 100;
      value = numberValue.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    }
    setFieldValue(value);
  };

  const handleSave = () => {
    if (fieldKey === "salary") {
      const errors = {};

      const numeric = Number((fieldValue?.salary || "").replace(/\D/g, "")) / 100;
      if (!numeric || numeric <= 0) {
        errors.salary = "Pretensão salarial deve ser maior que R$ 0,00";
      }
      if (fieldValue?.salaryNegotiable !== true && fieldValue?.salaryNegotiable !== false) {
        errors.salaryNegotiable = "Escolha se está aberto à negociação salarial";
      }
      if (Object.keys(errors).length > 0) {
        setErrors(errors);
        return;
      }
    }

    if (fieldKey === "contractType") {
      if (fieldValue === "" || fieldValue === undefined || fieldValue === null) {
        setErrors({ contractType: "Selecione uma opção válida" });
        return;
      }
    }

    if (fieldKey === "workModel") {
      if (!Array.isArray(fieldValue) || fieldValue.length === 0) {
        setErrors({ work_model: "Selecione pelo menos uma opção" });
        return;
      }
    }

    if (fieldKey === "bio") {
      if (fieldValue === "" || fieldValue === undefined || fieldValue === null) {
        setErrors({ bio: "A mini bio é obrigatória" });
        return;
      }
      if (fieldValue?.length < 200) {
        setErrors({ bio: "A mini bio deve ter no mínimo 200 caracteres" });
        return;
      }
      if (fieldValue?.length > 450) {
        setErrors({ bio: "A mini bio deve ter no máximo 450 caracteres" });
        return;
      }
    }

    if (fieldKey === "seniorityLevel") {
      if (fieldValue === "" || fieldValue === undefined || fieldValue === null) {
        setErrors({ seniorityLevel: "Selecione uma opção válida" });
        return;
      }
    }

    if (fieldKey === "linkedinUrl") {
      const value = (fieldValue || "").trim();
      const prefix = "https://www.linkedin.com/in/";

      if (!value) {
        setErrors({ linkedinUrl: "O campo LinkedIn é obrigatório" });
        return;
      }

      if (!value.startsWith(prefix)) {
        setErrors({ linkedinUrl: "O link do LinkedIn deve começar com https://www.linkedin.com/in/" });
        return;
      }
    }

    onSave();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style} className="modalInput">
        {fieldKey === "salary" ? (
          <>
            <div className="formGroup">
              <div className="containerInput">
                <TextInput
                  name="salary"
                  label="Pretensão Salarial"
                  value={
                    typeof fieldValue?.salary === "string"
                      ? fieldValue.salary.includes("R$")
                        ? fieldValue.salary
                        : (Number(fieldValue.salary) || 0).toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })
                      : "R$ 0,00"
                  }
                  onChange={(val) => {
                    setFieldValue((prev) => ({
                      ...prev,
                      salary: val,
                    }));
                  }}
                  placeholder="Informe sua pretensão salarial"
                  error={errors.salary}
                  maskType="currency"
                />
              </div>
            </div>
            <div className="formGroup">
              <div className="containerLabel">
              </div>
              <div className="containerInput">
                <SelectInput
                  name="salaryNegotiable"
                  label="Aberto à negociação salarial"
                  value={
                    fieldValue?.salaryNegotiable === true
                      ? "true"
                      : fieldValue?.salaryNegotiable === false
                        ? "false"
                        : ""
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    setFieldValue((prev) => ({
                      ...prev,
                      salaryNegotiable:
                        value === "true" ? true : value === "false" ? false : null,
                    }));
                  }}
                  options={[
                    { label: "Sim", value: "true" },
                    { label: "Não", value: "false" },
                  ]}
                  error={errors.salaryNegotiable}
                />
              </div>
            </div>
          </>
        ) : (fieldKey === "contractType" || fieldKey === "workModel" || fieldKey === "seniorityLevel") ? (
          <div className="formGroup">
            <div className="containerLabel">
            </div>
            <div className="containerInput">
              {fieldKey === "contractType" ? (
                <SelectInput
                  name={fieldKey}
                  label="Regime de Contratação"
                  value={fieldValue !== undefined && fieldValue !== null ? String(fieldValue) : ""}
                  onChange={(e) => {
                    const value = parseInt(e.target.value, 10);
                    setFieldValue(value);
                  }}
                  options={[
                    { label: "CLT", value: "0" },
                    { label: "PJ", value: "1" },
                    { label: "Ambos", value: "2" },
                  ]}
                  error={errors[fieldKey]}
                />
              ) : fieldKey === "seniorityLevel" ? (
                <div className="containerInput">
                  <SelectInput
                    name="seniorityLevel"
                    label="Nível de Senioridade"
                    value={fieldValue !== undefined && fieldValue !== null ? String(fieldValue) : ""}
                    onChange={(e) => {
                      const value = parseInt(e.target.value, 10);
                      setFieldValue(value);
                    }}
                    options={[
                      { label: "Auxiliar", value: "0" },
                      { label: "Assistente", value: "1" },
                      { label: "Analista Jr.", value: "2" },
                      { label: "Analista Pleno", value: "3" },
                      { label: "Analista Sênior", value: "4" },
                      { label: "Coordenador", value: "5" },
                      { label: "Gerente", value: "6" },
                      { label: "Diretor", value: "7" },
                      { label: "C-Level", value: "8" },
                    ]}
                    error={errors.seniorityLevel}
                  />
                </div>
              ) : (
                <MultiSelectInput
                  name="work_model"
                  label="Modelo de Trabalho"
                  value={Array.isArray(fieldValue) ? fieldValue : []}
                  onChange={(values) => {
                    setFieldValue(values)
                  }}
                  options={[
                    { label: "Presencial", value: "in_person" },
                    { label: "Home Office", value: "remote" },
                    { label: "Híbrido", value: "hybrid" },
                  ]}
                  placeholder="Selecione pelo menos uma opção"
                  error={errors?.work_model}
                />
              )}
            </div>
          </div>
        ) : (
          <>
            {fieldKey === "linkedinUrl" ? (
              <div className="formGroup">
                <div className="containerInput">
                  <TextInput
                    name="linkedinUrl"
                    label="LinkedIn"
                    value={fieldValue}
                    onChange={(val) => {
                      const prefix = "https://www.linkedin.com/in/";
                      let value = (val || "").trim();

                      if (value === "" || value === prefix) {
                        setFieldValue("");
                        return;
                      }

                      value = value.replace(/(https:\/\/)?(www\.)?linkedin\.com\/in\//gi, "");
                      value = value.replace(/^\/+/, "");

                      if (value.length > 0) {
                        setFieldValue(prefix + value);
                      } else {
                        setFieldValue("");
                      }
                    }}
                    placeholder="https://www.linkedin.com/in/seu-usuario"
                    error={errors.linkedinUrl}
                  />
                </div>
              </div>
            ) : fieldKey === "bio" ? (
              <div className="formGroup">
                <div className="containerInput">
                  <TextArea
                    name={fieldKey}
                    label="Mini bio"
                    value={fieldValue}
                    onChange={setFieldValue}
                    placeholder="Uma breve apresentação sua"
                    error={errors[fieldKey]}
                    minLength={200}
                    maxLength={450}
                  />
                </div>
              </div>
            ) : fieldKey === "birthdate" ? (
              <div className="formGroup">
                <div className="containerInput">
                  <TextInput
                    name={fieldKey}
                    label="Data de nascimento"
                    value={fieldValue}
                    onChange={setFieldValue}
                    placeholder="dd/mm/yyyy"
                    error={errors[fieldKey]}
                    maskType="date"
                  />
                </div>
              </div>
            ) : (
              <div className="formGroup">
                <div className="containerInput">
                  <TextInput
                    name={fieldKey}
                    label={{
                      salary: "Pretensão Salarial",
                      contractType: "Regime de Contratação",
                      workModel: "Modelo de Trabalho",
                      linkedinUrl: "LinkedIn",
                      city: "Cidade",
                      state: "Estado",
                      name: "Nome Completo"
                    }[fieldKey] || "Editar Informação"}
                    value={fieldValue}
                    onChange={setFieldValue}
                    placeholder={placeholder || ""}
                    error={errors[fieldKey]}
                  />
                </div>
              </div>
            )}
          </>
        )}
        <Button
          variant="contained"
          className="buttonSave"
          onClick={handleSave}
        >
          Salvar Alterações
        </Button>
      </Box>
    </Modal>
  );
};
